import { c as _c } from "react/compiler-runtime";
import { FeatherCheckSquare, FeatherClock, FeatherUsers } from '@subframe/core';
import type { BlocoResumoDecisao, IconeResumoDecisao } from '../../../types/sentencaArbitral.types';
import { SELO_RESUMO_AUTOMATICO, TEXTOS_SENTENCA_ARBITRAL } from './secoesSentencaArbitral';
import { TrechosSentenca } from './TrechosSentenca';
const ICONES_RESUMO: Record<IconeResumoDecisao, typeof FeatherCheckSquare> = {
  decisao: FeatherCheckSquare,
  partes: FeatherUsers,
  proximosPassos: FeatherClock
};
export function SecaoDecisaoIntro() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="px-[37px] pb-5"><p className="text-[14px] leading-[1.45] text-neutral-600">{TEXTOS_SENTENCA_ARBITRAL.decisaoIntro}</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
interface PainelResumoDecisaoProps {
  blocos: readonly BlocoResumoDecisao[];
}
export function PainelResumoDecisao(t0) {
  const $ = _c(8);
  const {
    blocos
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-[13px] flex items-center gap-[9px]"><span className="bg-brand-600 h-2 w-2 flex-none rounded-[2px]" /><span className="text-brand-600 text-[12px] font-bold tracking-[0.8px] uppercase">{TEXTOS_SENTENCA_ARBITRAL.decisaoResumoTitulo}</span></div>;
    t2 = <p className="mb-2 text-[11.5px] leading-[1.4] text-neutral-500">{SELO_RESUMO_AUTOMATICO}</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== blocos) {
    let t4;
    if ($[4] !== blocos.length) {
      t4 = (bloco, index) => {
        const Icone = ICONES_RESUMO[bloco.icone];
        return <div className={`flex gap-[14px] px-[18px] py-3 ${index < blocos.length - 1 ? "border-brand-100 border-b border-solid" : ""}`} key={bloco.id}><div className="flex w-8 flex-none flex-col items-center gap-1.5"><div className="border-brand-100 text-brand-600 flex h-8 w-8 items-center justify-center rounded-[9px] border border-solid bg-white"><Icone className="h-4 w-4" /></div><span className="text-[10px] font-bold tracking-[1px] text-neutral-400">{String(index + 1).padStart(2, "0")}</span></div><div><div className="text-brand-600 mb-[3px] text-[14px] font-bold">{bloco.titulo}</div><p className="text-[13.5px] leading-[1.6] text-pretty text-neutral-700"><TrechosSentenca trechos={bloco.trechos} /></p></div></div>;
      };
      $[4] = blocos.length;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    t3 = blocos.map(t4);
    $[2] = blocos;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="px-[37px] pb-6">{t1}{t2}<div className="border-brand-100 bg-brand-50 overflow-hidden rounded-[10px] border border-solid">{t3}</div></div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}